import { delegate } from '../utils/delegate.js';

/**
 * Checks whether a field is valid on a server (i.e. e-mail addresses, subdomains, etc.)
 *
 * <input class='check-validity' data-validity-check='/users/valid?email=' />
 *
 * When the field is changed, we'll pass the value to the route specified with the value appended.
 * That route should return JSON of the structure: { valid: true/false, error: 'human friendly error' }
 *
 * If an error is encountered, we'll disable the submit field associated with the form. If it is successful,
 * we'll ensure there are no other validity checks with errors, and if there aren't, we'll enable the field.
 *
 * Please ensure that submit buttons start disabled if you want to require a value.
 */

delegate({
  baseSelector: 'body',
  selector: '.check-validity',
  eventName: 'input',
  handler: async (e) => {
    const validityURL = e.target.dataset.validCheck + encodeURIComponent(e.target.value);
    const statusContainer = document.querySelector(e.target.dataset.statusText);
    const response = await fetch(validityURL);
    if (response.ok) {
      const json = await response.json();
      if (json.valid === true) {
        markValid(statusContainer);
      } else {
        markInvalid(statusContainer, json.error);
      }
    } else {
      // If we hit an error, let's just assume things are valid - server validation should catch this and we
      // don't want to leave users in a weird state.
      markValid(statusContainer);
    }
  }
});

function markInvalid(statusContainer, message) {
  statusContainer.innerHTML = `<i class='fa fa-times'></i>${message}`;
  statusContainer.classList.add('status-error');
  statusContainer.classList.remove('status-ok');

  statusContainer.closest('form').querySelectorAll('input[type="submit"]').forEach((button) => button.disabled = true);
}

function markValid(statusContainer) {
  statusContainer.innerHTML = "";
  statusContainer.classList.add('status-ok');
  statusContainer.classList.remove('status-error');

  const closestForm = statusContainer.closest('form');
  if (closestForm.querySelector('.status-error') === null) {
    // If no other fields are in error, enable the form.
    closestForm.querySelectorAll('input[type="submit"]').forEach((button) => button.disabled = false);
  }
}
